import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {DetailScreensService} from '../../detail-screens-module/services/detail-screens-service';
import {DomService} from '../../../../services/dom-service/dom.service';
import {PoNode} from './ponode.model';
import {ArrangementNodeComponent} from '../../arrangement-node/arrangement-node.component';
import {ExpiredNodeComponent} from '../../expired-node/expired-node.component';
import {MoreNodeComponent} from '../../more-node/more-node.component';
import {ListOfAdminCodes} from './list-of-admin-codes';
import {ProductOverviewService} from '../../../../services/product-overview/product-overview.service';
import {SpecificsLabel} from './specifics-label.model';
import {SpecificsLabelWrapper} from './specifics-label-wrapper.model';
import {DetailScreenComponent} from '../../detail-screens-module/detail-screen/detail-screen.component';
import {ProductOverviewRequest} from '../../../../services/product-overview/product-overview-request.model';
import {ToasterService} from '../../../../toaster-module/toaster-service/toaster.service';
import {PopupService} from '../../popup-component/popup.service/popup.service';
import {UiHelperService} from '../../../../services/shared/helpers/ui-helper.service';
import {Subscribable, Subscription} from 'rxjs';
import {MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions} from '@angular/material/tooltip';

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 1000,
  touchendHideDelay: 1000,
};

@Component({
  selector: 'app-ponode',
  templateUrl: './ponode.component.html',
  styleUrls: ['./ponode.component.css'],
  providers: [
    {provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults},
  ],
})

export class PONodeComponent implements OnInit, AfterViewInit {
  @ViewChild('po_node', {read: ViewContainerRef}) nodeContainer: ViewContainerRef;

  detailsComponent: DetailScreenComponent;
  secondDetailsComponent: DetailScreenComponent;
  children: any[] = [];
  hierarchyChildren: any[];
  data: PoNode;
  nodeType: string;
  nodeLevel;
  isLastChild: boolean;
  expandable: boolean;
  expanded: boolean;
  childComponentType;
  readonly maximumAmountOfChildrenForNode = 5;
  listOfInitializedArrangements: any[] = [];
  private listOfAdminCodes: string[] = ListOfAdminCodes;
  listOfArrangementsToCreate: any[] = [];
  allExpanded: boolean;
  productCluster: string;
  isBalanceToggle: boolean;
  _balanceToggleSubscription: Subscription = new Subscription();
  elementLevel3: HTMLElement;
  hasOtherLinks = ['02', '03', '04'];

  private newScreens = ['onlinekeys'];
  private URI = {
    onlinekeys: 'onlinekeys',
  };

  constructor(protected domService: DomService, protected detailScreensService: DetailScreensService,
              protected changeRef: ChangeDetectorRef, protected el: ElementRef, protected renderer: Renderer2,
              protected productOverviewService: ProductOverviewService, protected popupService: PopupService,
              protected uiHelper?: UiHelperService, private toasterService?: ToasterService,
  ) {
    this.allExpanded = false;
    this.isBalanceToggle = this.uiHelper.isBalanceToggleOn;
    this._balanceToggleSubscription = this.uiHelper.balanceToggleSubject
      .subscribe((value) => {
        this.isBalanceToggle = value;
      });
  }

  ngOnInit() {
    this.productCluster = ProductOverviewRequest.productCluster || '';
    if (this.hierarchyChildren && this.hierarchyChildren.length > 0) {
      this.data.count = this.countNumber(this.hierarchyChildren);
      this.data.count = this.checkNumber(this.data.count);
    }
  }

  ngAfterViewInit() {
    this.elementLevel3 = (this.el.nativeElement as HTMLElement).querySelector('.node-level-3');
    if (this.elementLevel3) {
      const productName = this.elementLevel3.querySelector('.product-name');
    }
  }

  createComponent(node: any, component: any) {
    this.changeRef.detectChanges();
    const viewRef = this.createViewRef(component);
    return this.constructComponentToReturn(viewRef, component, node);
  }

  createViewRef(component: any) {
    if (!this.nodeContainer) {
      return null;
    }
    return this.domService.addComponentToDOM(component, this.nodeContainer);
  }

  createComponentsAtIndex(component, nodes: PONodeComponent[], index: any) {
    const listOfComponents: PONodeComponent[] = [];
    if (!this.nodeContainer) {
      return null;
    }
    nodes.forEach((node: any) => {
      const viewRef = this.domService.addComponentToDOMAtIndex(component, this.nodeContainer, index);
      const componentToReturn = this.constructComponentToReturn(viewRef, component, node);
      this.listOfInitializedArrangements.splice(index, 0, componentToReturn);
      listOfComponents.push(componentToReturn);
      index++;
    });
    return listOfComponents;
  }

  private constructComponentToReturn(viewRef, component, node) {
    const componentToReturn = viewRef.instance as typeof component;
    componentToReturn.hierarchyChildren = node.children;
    componentToReturn.data = node.data;

    if (this.productCluster !== '') {
      componentToReturn.expanded = node.expandByProdCluster;
    }

    componentToReturn.expandable = !node.leaf;
    componentToReturn.nodeLevel = this.nodeLevel + 1;
    componentToReturn.detailsComponent = this.detailsComponent;
    componentToReturn['secondDetailsComponent'] = this.secondDetailsComponent;
    return componentToReturn;
  }

  createArrangementComponents(component, nodes: PONodeComponent[]): PONodeComponent[] {
    if (!this.nodeContainer) {
      return null;
    }
    nodes.forEach((node: any) => {
      const viewRef = this.domService.addComponentToDOM(component, this.nodeContainer);
      this.listOfInitializedArrangements.push(this.constructComponentToReturn(viewRef, component, node));
    });
  }

  public loadProductOverviewPopUp() {
    const requiredRequestData = {
      arrangementNumber: this.data.arrangementNumber,
      administrationCode: this.data.administrationCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: this.data.restrictedDataViewException,
      relationMarketSegmentCode: this.data.relationMarketSegmentCode,
    };
    this.popupService.openPopup('productservices', requiredRequestData);
  }

  initializeComponents() {

  }

  collapseComponent() {

  }

  countNumber(children): number {
    let number = 0;
    children.forEach((child) => {
      if (this.isCountedArrangement(child)) {
        number++;
        return number;
      }
      number += this.countNumber(child.children);
    });
    return number;
  }

  checkNumber(number) {
    if (number === 0) {
      if (this.data.product === 'Geld opnemen'
        || this.data.product === 'Geld storten') {
        this.expanded = false;
      }
      return '';
    }
    return number;
  }

  isCountedArrangement(child): boolean {
    return child.type !== 'HIERARCHY_TYPE' && child.data.statusCode !== '4';
  }

  onClick() {
    this.expanded = !this.expanded;
  }

  expand() {
    this.expanded = true;
    this.allExpanded = true;
  }

  collapse() {
    this.expanded = false;
    this.allExpanded = false;
  }

  getArrangementUrl() {
  }

  loadDetailPage() {
    this.detailScreensService.clearSecondDetailsScreen(this.secondDetailsComponent);
    this.addBusyCursor();
    const listOfChildArrangementNumbers: string[] = [];
    if (this.hierarchyChildren.length !== 0) {
      this.hierarchyChildren.forEach((child) => {
        if (this.isCountedArrangement(child)) {
          listOfChildArrangementNumbers.push(child.data.arrangementNumber);
        }
      });
    }

    if (this.newScreens.includes(this.data.detailsURI)) {
      this.addBusyCursor();
      const requestUrl = this.URI[this.data.detailsURI];
      this.detailScreensService.getDetailsPage(requestUrl, this.data.arrangementNumber, this.data.administrationCode,
        this.data.iban, this.data.bankCode, this.data.restrictedDataViewException, this.data.relationMarketSegmentCode)
        .subscribe((resp) => {
            this.detailsComponent.createScreen(resp, requestUrl, this.secondDetailsComponent);
            this.removeBusyCursor();
          },
          (error) => {
            this.toasterService.startErrorToast([error.description], '', true);
            this.removeBusyCursor();
          });
    } else {
      this.detailScreensService.getOldDetailsPage(this.data.detailsURI, this.data.arrangementNumber, this.data.administrationCode,
        this.data.commercialProductTypeCode, this.data.parentCustomerId, listOfChildArrangementNumbers)
        .subscribe((resp) => {
          this.detailsComponent.setOldDetails(resp, this.data.detailsURI);
          this.removeBusyCursor();
        });
    }

  }

  childIsArrangement(child): boolean {
    return (child['type'] === 'ARRANGEMENT_TYPE') || child.data.product.includes('vervallen');
  }

  childHasArrangements(child): boolean {
    if (child.children.length > 0) {
      return child.children.every((grandChild) => {
        return grandChild['type'] === 'ARRANGEMENT_TYPE' || (grandChild.data.product.includes('vervallen'));
      });
    }
    return false;
  }

  createArrangements() {
    this.changeRef.detectChanges();
    const expiredNode: ExpiredNodeComponent = this.getExpiredNodeFromList(this.listOfArrangementsToCreate);
    const overflowChildList: PONodeComponent[] = [];
    if (this.listOfArrangementsToCreate.length <= this.maximumAmountOfChildrenForNode) {
      this.createArrangementComponents(ArrangementNodeComponent, this.listOfArrangementsToCreate);
      this.changeRef.detectChanges();
    } else {
      this.createMoreNode(overflowChildList);
    }
    if (expiredNode) {
      this.listOfInitializedArrangements.push(this.createComponent(expiredNode, ExpiredNodeComponent));
      this.changeRef.detectChanges();
    }
    this.getListOfDetailsForArrangements(this.listOfInitializedArrangements);
    this.changeRef.detectChanges();
    return this.listOfInitializedArrangements;
  }

  private createMoreNode(overflowChildList) {
    overflowChildList = this.listOfArrangementsToCreate.splice(this.maximumAmountOfChildrenForNode,
      this.listOfArrangementsToCreate.length -
      this.maximumAmountOfChildrenForNode);
    this.listOfArrangementsToCreate.forEach((child) => {
      this.listOfInitializedArrangements.push(this.createComponent(child, ArrangementNodeComponent));
      this.changeRef.detectChanges();
    });
    this.listOfInitializedArrangements.push(this.addMoreNode(overflowChildList));
    this.changeRef.detectChanges();
  }

  private addMoreNode(overflowChildList) {
    let moreNode;
    const viewRef = this.createViewRef(MoreNodeComponent);
    moreNode = viewRef.instance as typeof MoreNodeComponent;
    moreNode.parent = this;
    moreNode.data = new PoNode();
    moreNode.expandable = true;
    moreNode.data.product = 'Meer tonen';
    moreNode.nodeLevel = this.nodeLevel + 1;
    moreNode.children = overflowChildList;
    return moreNode;
  }

  addHiddenChildren(componentsToAdd) {
    const index = this.listOfInitializedArrangements.length - 1;
    this.getListOfDetailsForArrangements(this.createComponentsAtIndex(ArrangementNodeComponent, componentsToAdd, index));
    this.removeMoreNodeFromListOfInitializedArrangements();
    this.children = this.listOfInitializedArrangements;
    this.changeRef.detectChanges(); // <-- Add this
    const numberOfChildren = this.children.length;
    if (numberOfChildren > 0) {
      this.children[numberOfChildren - 1].isLastChild = true;
    }
  }

  private removeMoreNodeFromListOfInitializedArrangements() {
    this.listOfInitializedArrangements.forEach( (item, index) => {
      if (item.nodeType === 'more-node') {
        this.listOfInitializedArrangements.splice(index, 1);
        item = undefined;
      }
    });
  }

  private getExpiredNodeFromList(listOfNodes): ExpiredNodeComponent {
    let expiredNode;
    listOfNodes.forEach((node) => {
      if (node.data.product && node.data.product.includes('vervallen')) {
        expiredNode = node as ExpiredNodeComponent;
      }
    });
    if (expiredNode) {
      this.listOfArrangementsToCreate.splice(this.listOfArrangementsToCreate.indexOf(expiredNode));
    }
    return expiredNode;
  }

  private getListOfDetailsForArrangements(children) {
    const arrangementList = [];
    children.forEach((arrangementNode) => {
      arrangementNode.data.restrictedDataViewException = this.data.restrictedDataViewException;
      if (this.listOfAdminCodes.includes(arrangementNode.data['administrationCode'] as string)) {
        arrangementList.push(
          {
            administrationCode: arrangementNode.data['administrationCode'],
            arrangementNumber: arrangementNode.data['arrangementNumber'],
          },
        );
      }
    });
    if (arrangementList.length !== 0) {
      this.productOverviewService.getDetails(arrangementList, this)
        .subscribe((resp) => {
          const listOfArrangementDetails = resp;
          if (listOfArrangementDetails) {
            this.setArrangementDetails(listOfArrangementDetails, children);
            this.changeRef.detectChanges();
          }
        });
    }
  }

  private setArrangementDetails(listOfArrangementDetails, children) {
    listOfArrangementDetails.forEach((detail) => {
      children.forEach((childArrangementNode) => {
        if ((childArrangementNode.data.arrangementNumber === detail['arrangementNumber'] ||
            childArrangementNode.data.arrangementNumber === detail['arrangementNumber'] + detail['currencyCode']) &&
          childArrangementNode.data.administrationCode === detail['administrationCode']) {
          childArrangementNode.data.restrictedData = detail['restrictedData'];
          childArrangementNode.data.specifics = detail['specifics'];
          childArrangementNode.data.specificsLabels = this.getSpecificsLabelsFromResponse(detail);
          childArrangementNode.data.abb = detail['abb'];
          childArrangementNode.data.abbDescription = detail['abbDescription'];
          childArrangementNode.data.totalAmount = detail['totalAmount'];
          childArrangementNode.data.totalAmountSuffix = detail['totalAmountSuffix'];
        }
      });
    });
  }

  private getSpecificsLabelsFromResponse(arrangementDetails): string {
    const labelsFromResponse: any[] = arrangementDetails['specificsLabels'];
    let specificsLabelWrapper: SpecificsLabelWrapper;
    if (labelsFromResponse && labelsFromResponse.length > 0) {
      specificsLabelWrapper = new SpecificsLabelWrapper();
      labelsFromResponse.forEach((labelFromResponse) => {
        const specificsLabel: SpecificsLabel = new SpecificsLabel();
        specificsLabel.labelName = labelFromResponse['labelName'];
        specificsLabel.labelValue = labelFromResponse['labelValue'];
        specificsLabelWrapper.specificsLabels.push(specificsLabel);
      });
    }

    if (specificsLabelWrapper) {
      return specificsLabelWrapper.getAggregatedLabel();
    }
  }

  loadProductServicesRequiredData() {
    return {
      arrangementNumber: this.data.arrangementNumber,
      administrationCode: this.data.administrationCode,
      relationRestrictedDataView: true,
      restrictedDataViewException: this.data.restrictedDataViewException,
      relationMarketSegmentCode: this.data.relationMarketSegmentCode,
    };
  }

  expandOrCollapseAll() {
    this.allExpanded = !this.allExpanded;
  }

  addBusyCursor() {
    document.body.classList.add('busy-cursor');
  }

  removeBusyCursor() {
    document.body.classList.remove('busy-cursor');
  }

  public logHoverAmount() {
    return this.data.restrictedData;
  }

}
